<template>
  <i
    v-tooltip="$t('buttonFieldActionsCreditInfo.tooltip')"
    class="button-field-actions-credit-info iconoir-info-empty"
  ></i>
</template>

<script>
export default {
  name: 'ButtonFieldActionsCreditInfo',
  props: {
    workspace: {
      type: Object,
      required: false,
      default: null,
    },
  },
}
</script>
